import {useMutation} from '@apollo/client';
import {UPDATE_BANK_ACCOUNT} from "../bankAccountTypeDefs";

export const useMutationUpdateBankAccount = (options?: any): any => (
  useMutation(UPDATE_BANK_ACCOUNT, options)
);
